import React from 'react'

export default function MarkerPinIcon({ color = '#667085' }) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 10.8327C12.0474 10.8327 13.1667 9.71339 13.1667 8.33268C13.1667 6.95197 12.0474 5.83268 10.6667 5.83268C9.28595 5.83268 8.16667 6.95197 8.16667 8.33268C8.16667 9.71339 9.28595 10.8327 10.6667 10.8327Z"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 18.3327C14 14.9993 17.3333 12.0146 17.3333 8.33268C17.3333 4.65078 14.3486 1.66602 10.6667 1.66602C6.98477 1.66602 4 4.65078 4 8.33268C4 12.0146 7.33333 14.9993 10.6667 18.3327Z"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
